<!-- eslint-disable vue/multi-word-component-names -->
<script>
	import ShowDay from "../components/ShowDay.vue";
	import LabelDay from "../components/LabelDay.vue";
	import TitleMonth from "../components/TitleMonth.vue";
	import TotalsMonth from "../components/TotalsMonth.vue";

	import { mapState } from "vuex";
	import { possuiPermissao } from "../helpers/permissions";
	import { DashboardService } from "@/services/dashboard";
	import { stringToNumber } from "@/helpers/common";
	import ListTransaction from "@/components/Transactions/ListTransaction.vue";

	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import { ptBR } from "vuejs-datepicker/dist/locale";

	import Toast from "@/components/Toast";
	import ChartMedia from "@/components/charts/ChartMedia.vue";
	import { ref } from "vue";
	import emitter from "@/eventBus.js";

	export default {
		components: {
			ShowDay,
			LabelDay,
			TitleMonth,
			TotalsMonth,
			Toast,
			ChartMedia,
			ListTransaction
		},

		data () {
			return {
				hideHeaderModal: true,
				ptBR,
				diasSemana: [],
				calendario: [],
				optionsTitleMes: {},
				totalesMes: {},
				showTotales: false,
				dateSearch: new Date(),
				isLoading: true,
				dashboardService: new DashboardService(),
				possuiPermissao,
				titleModalPaymentsOfDay: "",
				optionModalAccount: [],
				sortTable: {
					sortBy: 3,
					order: -1
				},
				loading: false,
				subscriptionActive: true,
				messageToast: "",
				variantToast: "",
				params: {},
				showTransactions: false,
				forceChartUpdate: 0,
				isMobile: false,
				intervalId: null
			};
		},

		watch: {
			account () {
				this.findAccount();
			},
			category () {
				this.findCategoryExpenses();
			}
		},

		computed: {
			...mapState(["sideBarWidth", "account", "category", "customer", "showCharts"])
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
			clearInterval(this.intervalId);

			emitter.off("reloadTransactions");
		},

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			await this.getDashboard();
			this.findAccount();
			this.findCategoryExpenses();

			const currentDate = ref(new Date().toDateString());
			this.intervalId = setInterval(() => {
				const now = new Date().toDateString();
				if (now !== currentDate.value) {
					currentDate.value = now;
					this.getDashboard();
				}
			}, 60000);

			emitter.on("reloadTransactions", (reload) => {
				if (reload) {
					this.getDashboard();
				}
			});
		},

		methods: {
			async getDashboard () {
				this.isLoading = true;
				this.diasSemana = await this.dashboardService.weekDays({ date: this.dateSearch }) || this.getDiasSemana();
				const resCalendar = await this.dashboardService.calendar({ date: this.dateSearch }) || this.getCalendar(this.dateSearch);
				this.calendario = resCalendar.calendar;
				this.optionsTitleMes = resCalendar.monthOptions;
				this.totalesMes = resCalendar.totales;
				this.isLoading = false;
				const { subscriptionActive } = await JSON.parse(localStorage.params);
				this.variantToast = subscriptionActive;
				this.subscriptionActive = Boolean(!this.variantToast);
				if (this.variantToast === "error") {
					this.messageToast = "Renove assinatura para ativar as funcionalidades!";
				} else if (this.variantToast === "success") {
					this.messageToast = "Parabéns, solicite ativação das funcionalidades!";
				} else {
					this.messageToast = "Sua assinatura está vencida, faça renovação e evite bloqueo das funcionalidades!";
				}

			},

			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			async findMonth (value) {
				this.isLoading = true;

				if (typeof value === "object") {
					this.dateSearch = value?.date || new Date();
				} else {
					const month = this.dateSearch.getMonth();

					switch (value) {
						case -1:
							this.dateSearch.setMonth(month - 1);
							break;
						case 1:
							this.dateSearch.setMonth(month + 1);
							break;
						default:
							break;
					}
				}

				const resCalendar = await this.dashboardService.calendar({ date: this.dateSearch }) || this.getCalendar(this.dateSearch);
				this.calendario = resCalendar.calendar;
				this.optionsTitleMes = resCalendar.monthOptions;
				this.totalesMes = resCalendar.totales;
				this.isLoading = false;
			},

			getCalendar (date) {
				this.isLoading = true;
				const _date = new Date(date);
				const currentDate = new Date();
				const month = _date.getMonth();
				const year = _date.getFullYear();
				const dateNextMonth = new Date(year, month + 1, 1);
				dateNextMonth.setDate(dateNextMonth.getDate() - 1);
				const daysOfMonth = dateNextMonth.getDate();
				const firtDayOfMonth = (new Date(_date.getFullYear(), _date.getMonth(), 1)).getDay();
				const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
				const calendar = [];

				let day = 0;
				for (let idx = 0; idx <= 42; idx++) {
					if (idx < firtDayOfMonth || day >= daysOfMonth)
						calendar.push({ show: false });
					else {
						day++;
						const dayCalendar = (new Date(year, month, day));
						if (dayCalendar.getTime() === today.getTime())
							calendar.push({ day, value: "0,00", show: true, backColor: "white", color: "red", today: true, colorTextDay: "black" });
						else if (dayCalendar.getTime() < today.getTime())
							calendar.push({ day, value: "0,00", show: true, backColor: "grey", color: "black", colorTextDay: "black" });
						else
							calendar.push({ day, value: "0,00", show: true, backColor: "white", color: "black", colorTextDay: "black" });
					}
				}
				const monthOptions = {
					label: `${_date.toLocaleString("pt-BR", { month: "long" })}, ${year}`,
					color: "",
					backColor: "rgb(200, 198, 198, 1)"
				};
				this.isLoading = false;
				return { monthOptions, calendar };
			},

			getDiasSemana () {
				return [
					{backcolor: "grey", color: "black", label: "Sun"},
					{backcolor: "grey", color: "black", label: "Mon"},
					{backcolor: "grey", color: "black", label: "Tue"},
					{backcolor: "grey", color: "black", label: "Wed"},
					{backcolor: "grey", color: "black", label: "Thu"},
					{backcolor: "grey", color: "black", label: "Fri"},
					{backcolor: "grey", color: "black", label: "Sab"}
				];
			},

			handleShowTotales () {
				this.showTotales = !this.showTotales;
			},
			setDayPaymentSchedule (item) {
				this.item = item;
				const amount = stringToNumber(this.item.value);

				if (amount)
					this.getPaymentScheduleOfDay();
			},

			async getPaymentScheduleOfDay () {
				const item = this.item;

				const sortTable = this.sortTable;
				const dateSearchOfDay = new Date(this.dateSearch);
				dateSearchOfDay.setDate(item.day);
				this.titleModalPaymentsOfDay = `Agendamentos do día ${dayjs(dateSearchOfDay).locale("pt-br").format("DD-MM-YYYY")}`;
				const filters = {
					initDate: dayjs(dateSearchOfDay).locale("pt-br").format("YYYY-MM-DD"),
					endDate: dayjs(dateSearchOfDay).locale("pt-br").format("YYYY-MM-DD"),
					status: [{ value: 0, text: "Em aberto" }],
					dateSearch: [{ value: 1, text: "Vencimento" }],
					transactionType: [ "TOPAY", "RECURRING" ],
					sortTable
				};

				dateSearchOfDay.setDate(item.day);
				this.params = {
					filters,
					pagination: {
						limit: { value: 0 },
						page: 1
					}
				};
				this.$refs.modalPaymentsOfDay.show();
				this.showTransactions = true;
			},

			closeModal () {
				this.showTransactions = false;
				this.$refs.modalPaymentsOfDay.hide();
			},

			async findAccount () {
				this.optionModalAccount = this.account;
			},

			async findCategoryExpenses () {
				this.selectCategoryExpenses = this.category.map(item => ({ nome: item.description, value: item.idCategoryExpense })) || [];
			},

			rowsRequest (rows) {
				if (!rows)
					this.closeModal();
			},

			changeDateSearch (date) {
				this.findMonth(date);
			}
		}
	};
</script>

<template>
  <main
    v-if="possuiPermissao('DASHBOARD_CALENDARIO_V')"
    :style="`width: calc(100% - ${sideBarWidth}px) !important; transform: translateX(${sideBarWidth}px) !important; transition: all 0.6s !important; margin-top: 1rem !important`"
	class="dashboard"
  >
	<div>
		<Toast
			:visible="!subscriptionActive"
			:variant="variantToast"
			:onlyWatch="true"
			toast_align="up"
			:message="messageToast"
			:hideOnClick="true"
			:showAfterHide="true"
			@clickToast="$router.push({ path: '/renovar'})"
		/>
		<div>
			<TotalsMonth
				class="totals-month"
				v-if="showCharts && showCharts.find(ele => ele.value === 1)"
				style="margin-top: 14px"
				:options="totalesMes"
				:show="true"
				:showHideButton="false"
				:showAccountBalance="possuiPermissao('REL_V_CONTAS')"
				@click="handleShowTotales"
				:isLoading="isLoading"
				:date="dateSearch"
			/>
			<!-- <div id="grid" v-bind:class="isMobile || showCharts.length < 2 ? 'grid-6' : 'grid-3x2'"> -->
			<div id="grid" v-bind:class="isMobile || showCharts.length < 2 ? 'grid-6' : 'grid-6'">
				<div class="item d-block">

					<section class="title-month">
						<button
							class="button-arrow"
							@click="findMonth(-1)"
						>
							<ChevronsLeftIcon class="icons-chevrons" color="var(--cal-header-color)"/>
						</button>
						<TitleMonth
							:options="{
								label: optionsTitleMes.label || null,
								backColor: optionsTitleMes.backColor || null,
								color: optionsTitleMes.color || null,
							}"
							style="width: 90% !important; z-index: 1000 !important"
							:dateSearch="dateSearch"
							@changeDateSearch="changeDateSearch"
							:isMobile="isMobile"

						/>
						<button
							class="button-arrow"
							@click="findMonth(1)"
						>
							<ChevronsRightIcon class="icons-chevrons" color="var(--cal-header-color)"/>
						</button>
					</section>
					<section class="calendar">
						<div
							v-for="diaSem in diasSemana"
							:key="diaSem.ordem"
							>
							<LabelDay
								:options="{
								label: diaSem.label,
								backColor: diaSem.backColor,
								color: diaSem.color,
								}"
							/>
							</div>
							<div v-for="item in calendario" :key="item.day">
							<ShowDay
								:options="{
								day: item.day,
								value: item.value,
								show: item.show,
								color: item.color,
								backColor: item.backColor,
								colorTextDay: item.colorTextDay,
								today: item.today,
								}"
								@clickShowDay="setDayPaymentSchedule(item)"
							/>
						</div>
						<div
							v-if="isLoading"
							style="position: fixed; height: 50vh; width: 100%; display: flex; align-items: center; justify-content: center;">
							<div class="spinner-border" role="status">
								<span class="sr-only">Carregando...</span>
							</div>
						</div>
					</section>
				</div>
				<ChartMedia
					class="item"
					v-if="(showCharts && showCharts.find(ele => ele.value === 2))?.value"
					:title="`Análise Comparativa - ${optionsTitleMes.label}`"
					type="pie"
					:searchDate="dateSearch"
					:showXAxisLabel="false"
					:showZoom="false"
					:chartKey="Number('2')"
					:forceUpdate="forceChartUpdate"
				/>
				<ChartMedia
					class="item"
					v-if="(showCharts && showCharts.find(ele => ele.value === 3))?.value"
					:title="`Despesas por categorias - ${optionsTitleMes.label}`"
					:searchDate="dateSearch"
					:showXAxisLabel="true"
					:showZoom="true"
					:chartKey="Number('3')"
					:showLegend="false"
					:forceUpdate="forceChartUpdate"
				/>
				<ChartMedia
					class="item"
					v-if="(showCharts && showCharts.find(ele => ele.value === 4))?.value"
					:title="`Receitas por categorias - ${optionsTitleMes.label}`"
					:searchDate="dateSearch"
					:showXAxisLabel="true"
					:showZoom="true"
					:chartKey="Number('4')"
					:showLegend="false"
					:forceUpdate="forceChartUpdate"
				/>
			</div>
		</div>

		<b-modal
			ref="modalPaymentsOfDay"
			hide-footer
			:hide-header="hideHeaderModal"
			size="xl"
			no-overflow
			hide-no-focus
			no-close-on-backdrop
			hide-header-close
		>
			<div class="title-modal" v-if="showTransactions">
				<div class="title-text-modal">{{titleModalPaymentsOfDay}}</div>
				<div
					class="float-right btn-hover-modal"
					@click="closeModal"
				>
					<xIcon/>
				</div>
			</div>
			<div class="mt-5 mb-3">
				<ListTransaction
					v-if="showTransactions"
					:showTopMenuAdd="false"
					:showTopMenuFilter="false"
					:filtersFixed="params.filters"
					:paginationFixed="params.pagination"
					:showPagination="false"
					@rowsRequest="rowsRequest"
				/>
			</div>
		</b-modal>
	</div>
  </main>
</template>

<style scoped>
#grid {
	display: grid;
	gap: 10px
}

.grid-3x2 {
  grid-template-columns: repeat(2, calc(50% - 5px));
  grid-template-rows: repeat(3, auto);
}

.grid-6x1 {
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 60px);
}

.totals-month {
	display: flex;
	align-items: center;
	justify-content: center;
}

.calendar {
  display: grid;
  padding: 0px;
  width: 100%;
  grid-template-columns: repeat(7, 1fr);
  background: azure;
}

.title-month {
  background: azure;
  display: flex;
  width: 100%;
  margin-top: 14px;
}

.button-arrow {
  display: flex;
  width: 5%;
  background: var(--color-button-grey);
  border-style: outset;
  border-color: var(--color-button-grey-hover);
  border-width: 1px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}

.button-arrow:hover {
  background: var(--color-button-grey-hover);
}

.button-arrow:focus {
  background: var(--color-green-light);
}

.modal-edicao-input {
	font-family: 'Roboto Condensed Regular';
	font-size: 1rem;
}

.number-class {
	text-align: right;
}

.label-parcela {
  margin-bottom: 0px;
  color: #696969 !important;
  width: 10rem;
}

.text-parcela {
  font-family: 'Roboto Condensed Regular';
  font-size: 16px;
}

.btn-salvar-top {
  width: 11.25rem;
  white-space: noWrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 8px;
}

.table-margin-top {
  margin-top: calc(50px + 2rem);
}

.responsive-filter-modal {
	display: flex;
	justify-content: space-evenly;
}
.filter-rows {
	width: 50%;
	padding: 1.25rem 0 1.25rem 1.25rem;
	font-size: 1.15rem;
}
.filter-rows-next {
	padding-left: 0.8rem;
	padding-right: 1.25rem;
}

.icon-payment {
	display: flex;
	justify-content: center;
	background-color: green;
	color: white;
	padding: 2px;
}

.icon-delete {
	display: flex;
	justify-content: center;
	background-color: red;
	color: white;
	padding: 2px;
}


.label-parcela {
	margin-bottom: 0px;
	color: #696969 !important;
	width: 10rem;
}

.text-parcela {
	font-family: 'Roboto Condensed Regular';
	font-size: 1rem;
}

.table-parcelas {
	padding-left: 2rem;
	margin-bottom: 12px;
	max-height: 25vh;
	overflow-y: scroll;
	overflow-x: hidden;
	border: solid 1px #e2e2e2;
	background-color: #f7f5f5;
	border-top: none;
}

.justify-items {
	align-items: center;
}

.label-table {
	background-color: #f0efef;
	font-family: 'Roboto Condensed Regular';
	color: #696969 !important;
	border: solid 1px #e2e2e2;
	border-bottom: none;
	height: 3rem;
}

.modal-edicao-input {
	font-family: 'Roboto Condensed Regular';
	font-size: 1rem;
}

.dashboard {
	padding-left: 8px;
	padding-right: 8px;
}

.select-dashboard {
	min-width: 130px;
	max-width: 300px;
	width: 20%;
	font-family: "Roboto Condensed Regular";
	font-size: 0.875rem;
}

.section-select-dashboard {
	position: fixed;
	top: 54px;
	right: 2px;
	z-index: 999;
}

@media (max-width: 1576px) {
  .button-arrow {
    width: 6%
  }
}

@media (max-width: 1024px) {
  .button-arrow {
    width: 9%
  }
}

@media (max-width: 768px) {
	.responsive-filter-modal {
		display: block;
	}
	.filter-rows {
		padding-left: 1.8rem;
		padding-right: 0;
		width: 100%;
	}
	.filter-rows-next {
		padding-top: 0;
		margin-top: -1rem;
	}

	.totals-month {
		margin-top: -8px !important;
}
}


@media (max-width: 600px) {
  .button-arrow {
    width: 11%
  }
}
</style>